import {
    isEmail,
    minDigitsLength,
    maxDigitsLength,
    isNumber,
    isTextFieldNotEmpty,
    isSumm,
    isFieldEmpty,
} from './../utils/customValidators'
import {
    SUCCESS_MESSAGE,
    SUCCESS_MESSAGE_SHORT,
    ERROR_MESSAGE,
    ERROR_FIELD,
    ERROR_MAIL,
    PHONE_LONG,
    PHONE_SHORT,
    ERROR_NUMBERS_ONLY,
    ACCEPTANCE_FALSE,
    CAPTCHA_FALSE,
} from './../utils/messages'

import IMask from 'imask'

const FORM_URL = '/forms/submit.php'
let captchaNum1, captchaNum2, encodedNum1, encodedNum2
const forms = document.querySelectorAll('form.order-form')

function generateCaptcha(form) {
    const captchaInput = form.querySelector('input[name="check"]')
    if (!isSumm(captchaInput.value, captchaNum1, captchaNum2)) {
        captchaNum1 = Math.floor(Math.random() * 10) + 1
        captchaNum2 = Math.floor(Math.random() * 10) + 1
        encodedNum1 = btoa(captchaNum1.toString())
        encodedNum2 = btoa(captchaNum2.toString())

        if (form.encoded_num1) {
            form.encoded_num1.value = encodedNum1
        } else {
            const input1 = document.createElement('input')
            input1.type = 'hidden'
            input1.name = 'encoded_num1'
            input1.value = encodedNum1
            form.appendChild(input1)
        }

        if (form.encoded_num2) {
            form.encoded_num2.value = encodedNum2
        } else {
            const input2 = document.createElement('input')
            input2.type = 'hidden'
            input2.name = 'encoded_num2'
            input2.value = encodedNum2
            form.appendChild(input2)
        }

        form.querySelector('.js-check-text').textContent = `${captchaNum1} + ${captchaNum2} = ?*`
    }
}

function highlight(element, msg = ERROR_FIELD) {
    unhighlight(element)
    element.classList.add('error')

    const errorElement = document.createElement('span')

    errorElement.classList.add('error-message')
    errorElement.textContent = msg

    element.insertAdjacentElement('afterend', errorElement)
}

function unhighlight(element) {
    element.classList.remove('error')

    const nextEl = element.nextElementSibling

    if (nextEl && nextEl.classList.contains('error-message')) {
        nextEl.remove()
    }
}

function getErrorForInput(input, form) {
    if (input.hasAttribute('required')) {
        if (isFieldEmpty(input)) {
            return ERROR_FIELD
        }
    }

    // For email validation
    if (input.name === 'email' && input.hasAttribute('required')) {
        if (!isEmail(input.value)) {
            return ERROR_MAIL
        }
    }

    const textFields = ['your-name']

    if (textFields.includes(input.name)) {
        if (!isTextFieldNotEmpty(input.value)) {
            return ERROR_FIELD
        }
    }

    // For phone validation
    if (input.name === 'phone' && input.hasAttribute('required')) {

        if (!isNumber(input.value)) {
            return ERROR_NUMBERS_ONLY
        }

        if (!minDigitsLength(input.value, input, 6)) {
            return PHONE_SHORT
        }
        if (!maxDigitsLength(input.value, input, 11)) {
            return PHONE_LONG
        }
    }

    if (input.name == 'acceptance' && !input.checked) {
        return ACCEPTANCE_FALSE
    }

    // For captcha validation
    if (input.name === 'check') {
        captchaNum1 = Number(atob(form.encoded_num1.value))
        captchaNum2 = Number(atob(form.encoded_num2.value))
        if (!isSumm(input.value, captchaNum1, captchaNum2)) {
            return CAPTCHA_FALSE
        }
    }

    return null
}

function isValidForm(form) {
    let isValid = true

    const inputs = form.querySelectorAll('input')

    inputs.forEach((input) => {
        const isValidValue = isValidInput(input, form)

        if (!isValidValue) {
            isValid = false
        }
    })

    return isValid
}

function isValidInput(input, form) {
    const errorMsg = getErrorForInput(input, form)
    if (errorMsg) {
        highlight(input, errorMsg)

        return false
    }
    unhighlight(input)

    return true
}

export function initFormValidation() {
    forms.forEach((form) => {
        generateCaptcha(form)
    })

    document.querySelectorAll("input[name='phone']").forEach((input) => {
        // eslint-disable-next-line new-cap
        IMask(
            input,
            {
                mask: '+{7} (000) 000-00-00',
            },
        )
    })

    forms.forEach((form) => {
        // add form reset
        form.addEventListener('reset', () => {
            // clear form fields
            form.querySelectorAll('input').forEach((input) => {
                // skip submit input
                if (input.type === 'submit') {
                    return
                }
                // skip hidden inputs
                if (input.type === 'hidden') {
                    return
                }

                if (input.type === 'checkbox') {
                    input.checked = true
                }

                unhighlight(input)
                input.value = ''
            })
        })

        form.addEventListener('submit', (event) => {
            event.preventDefault()

            // Check if body already has loading class
            if (document.body.classList.contains('is-sending')) {
                return
            }

            if (isValidForm(form)) {
                // Add loading class
                document.body.classList.add('is-sending')

                const formData = new FormData(form)
                const isFormShort = form.dataset?.formType === 'short'
                let successMessage = ''

                if (form.dataset?.successMessage) {
                    successMessage = form.dataset.successMessage
                } else if (isFormShort) {
                    successMessage = SUCCESS_MESSAGE_SHORT
                } else {
                    successMessage = SUCCESS_MESSAGE
                }

                fetch(FORM_URL, {
                    method: 'POST',
                    body: formData,
                })
                    .then((response) => {
                        // Remove loading class
                        document.body.classList.remove('is-sending')

                        if (!response.ok) {
                            throw new Error('Network response was not ok')
                        }

                        return response.json()
                    })
                    .then((result) => {
                        const outputMessage = form.querySelector('.form-row__output')

                        if (result.success) {
                            const formContents = form.querySelectorAll('.order__form-content')

                            // eslint-disable-next-line max-nested-callbacks
                            formContents.forEach((item) => {
                                item.classList.add('hidden')
                            })
                            outputMessage.classList.remove('error')
                            outputMessage.classList.add('success')
                            outputMessage.innerHTML = successMessage
                            // if .modal has .modal--dark class
                            let yandexGoal = 'order_platform'
                            if (form.querySelector('.modal.modal--dark')) {
                                yandexGoal = 'order_franshiza'
                            }

                            try {
                                // eslint-disable-next-line no-undef
                                ym(95519912, 'reachGoal', yandexGoal)
                            } catch (error) {
                                // eslint-disable-next-line no-console
                                console.error('YM undefined:', error)
                            }

                            form.reset()
                        } else {
                            outputMessage.classList.remove('success')
                            outputMessage.classList.add('error')
                            outputMessage.textContent = ERROR_MESSAGE
                        }
                    })
                    .catch((error) => {
                        // Remove loading class
                        document.body.classList.remove('is-sending')

                        // eslint-disable-next-line no-console
                        console.error(error)
                    })
            } else {
                const outputMessage = form.querySelector('.form-row__output')
                outputMessage.classList.remove('success')
                outputMessage.classList.add('error')
                outputMessage.textContent = ERROR_MESSAGE
                generateCaptcha(form)
            }
        })

        form.addEventListener('input', (event) => {
            if (isValidInput(event.target, form)) {
                unhighlight(event.target)
            }
        })
    })
}
